import React from "react";
import {
  View,
  StyleSheet,
  TextInput,
  Platform,
  KeyboardAvoidingView,
} from "react-native";
import {Color, globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import {useDispatch} from "react-redux";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from '../../../utils/globalConstant';
import {isMobile} from '../../../utils/commonMethods';

const KycDetails = ({bankDetails}) => {
  const dispatch = useDispatch();
  const bankdetails = bankDetails?.bankdetails;
  const panNumber = bankdetails?.number;
  const accountHolderName = bankdetails?.name;
  const neftCode = bankdetails?.ifsc;
  const account = bankdetails?.accountnumber;

  const formatPanNumber = (pan) => {
    if (!pan) return '';
    return `${pan.slice(0, 2).toUpperCase()}******${pan.slice(-1).toUpperCase()}`;
  };

  const formatIfscCode = (ifsc) => {
    if (!ifsc) return '';
    return ifsc.toUpperCase();
  };

  return (
    <KeyboardAvoidingView
      behavior="height"
      keyboardVerticalOffset={0}>
      <View style={styles.contentContainer}>
        <FormTextLabel
          labelStyles={styles.labelStyle}
          label={"PAN Number"}
        />
        <View style={styles.inputDiv}>
          <TextInput
            style={styles.inputStyle}
            value={formatPanNumber(panNumber)}
            placeholderTextColor={globalConfigurableData.secondaryTextColor1}
            placeholder="Enter your 10-digit PAN"
            editable={false}
          />
        </View>
        <FormTextLabel
          labelStyles={styles.labelStyle}
          label={"IFSC Code"}
        />
        <View style={styles.inputDiv}>
          <TextInput
            style={styles.inputStyle}
            value={formatIfscCode(neftCode)}
            placeholderTextColor={globalConfigurableData.secondaryTextColor1}
            placeholder="Write IFSC Code here"
            keyboardType="numeric"
            editable={false}
          />
        </View>
        <FormTextLabel
          labelStyles={styles.labelStyle}
          label={"Account Number"}
        />
        <View style={styles.inputDiv}>
          <TextInput
            style={styles.inputStyle}
            value={account}
            placeholderTextColor={globalConfigurableData.secondaryTextColor1}
            placeholder="Enter account number"
            keyboardType="numeric"
            editable={false}
          />
        </View>
      </View>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    paddingTop: 16,
  },
  inputDiv: {
    borderWidth: 1,
    borderColor: globalConfigurableData.borderColor,
    borderRadius: 8,
    marginBottom: 16,
    backgroundColor: globalConfigurableData.cardBgColor,
  },
  inputStyle: {
    height: 48,
    paddingHorizontal: 16,
    color: globalConfigurableData.primaryTextColor1,
    ...globalFontStyle.appFontRegular,
  },
  labelStyle: {
    ...globalFontStyle.appFontRegular,
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 8,
  },
});

export default KycDetails;
